export default __webpack_public_path__ + "static/media/natural.88710973.svg";